import { render, staticRenderFns } from "./ModeloDocumento.vue?vue&type=template&id=3d91de00"
import script from "./ModeloDocumento.vue?vue&type=script&lang=js"
export * from "./ModeloDocumento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports